import es from "date-fns/locale/es";
import { useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import SolicitudesA1 from "../solicitudesA1/SolicitudesA1";
import SolicitudesA2 from "../solicitudesA2/SolicitudesA2";
import "./AcumuladoresTab.scss";

registerLocale("es", es);
const AcumuladoresTabAdquisicion = ({
  solicitudesA1,
  solicitudesA2,
  selectedIndexFunc,
}) => {
  const [dataAdquisicion] = useState(
    JSON.parse(localStorage.getItem("dataAdquisicion"))
  );
  const displayTabs = () => {
    return (
      <Tabs
        defaultIndex={0}
        /*onSelect={(index) => */
        selectedTabClassName="tab-selected"
        onSelect={(index) => selectedIndexFunc(index)}
      >
        <TabList>
          {dataAdquisicion.a1 ? (
            <>
              <Tab>Solicitudes A1</Tab>
            </>
          ) : null}

          {dataAdquisicion.a2 ? (
            <>
              <Tab>Solicitudes A2</Tab>
            </>
          ) : null}
        </TabList>
        {dataAdquisicion.a1 || dataAdquisicion.a2 ? (
          <>
            {dataAdquisicion.a1 ? (
              <>
                <TabPanel>
                    <SolicitudesA1 solicitudesA1={solicitudesA1} />
                </TabPanel>
              </>
            ) : null}
            {dataAdquisicion.a2 ? (
              <>
                <TabPanel>
                    <SolicitudesA2 solicitudesA2={solicitudesA2} />
                </TabPanel>
              </>
            ) : null}
          </>
        ) : (
          <>
            <SpinnerCircle></SpinnerCircle>
          </>
        )}
      </Tabs>
    );
  };

  return (
    <>
      <div className="acumuladoresTab col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div>{displayTabs()}</div>
      </div>
    </>
  );
};
export default AcumuladoresTabAdquisicion;
